'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import Stage from '../lib/services/stage/stage';
import BootSplash from './boot-splash';

const DemoClient = dynamic(() => import('./democlient'), {
  ssr: false,
  loading: () => <BootSplash preflight />,
});

export default function Page() {
  const router = useRouter();
  const [status, setStatus] = useState<'checking' | 'supported' | 'unsupported'>('checking');

  useEffect(() => {
    let cancelled = false;

    async function check() {
      const stage = Stage.instance();
      const supported = await stage.detect_webgpu_support();

      if (cancelled) return;

      if (!supported) {
        setStatus('unsupported');
        router.replace('/unsupported');
        return;
      }

      setStatus('supported');
    }

    check();

    return () => {
      cancelled = true;
    };
  }, [router]);

  if (status !== 'supported') {
    return <BootSplash preflight />;
  }

  return <DemoClient />;
}
